"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChecklistItemType = void 0;
var ChecklistItemType;
(function (ChecklistItemType) {
    ChecklistItemType["UNKNOWN"] = "UNKNOWN";
    ChecklistItemType["TOP_CHOICE"] = "TOP_CHOICE";
    ChecklistItemType["TOP_EARLY_APPLICANT"] = "TOP_EARLY_APPLICANT";
    ChecklistItemType["AI_INTERVIEW"] = "AI_INTERVIEW";
    ChecklistItemType["PROFILE_ENGAGEMENT"] = "PROFILE_ENGAGEMENT";
})(ChecklistItemType || (exports.ChecklistItemType = ChecklistItemType = {}));
